// Mock product catalogue for Flownté Clothing
// All product imagery uses curated editorial/fashion photography from Unsplash & Pexels
// matching the soft blush + rose + cream aesthetic defined in design_guidelines.json.

export const CATEGORIES = [
  {
    id: "casual",
    name: "Casual Kurtis",
    caption: "Effortless everyday elegance",
    image:
      "https://images.unsplash.com/photo-1768033976358-875c5dd27fc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "festive",
    name: "Festive Kurtis",
    caption: "Heirloom-worthy statement pieces",
    image:
      "https://images.pexels.com/photos/14045669/pexels-photo-14045669.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "daily",
    name: "Daily Wear",
    caption: "Soft silhouettes for quiet mornings",
    image:
      "https://images.unsplash.com/photo-1767687700430-d1b2997ae598?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

const SIZES = ["XS", "S", "M", "L", "XL"];

export const PRODUCTS = [
  {
    id: "rose-mirage",
    name: "Rose Mirage Short Kurti",
    price: 2490,
    originalPrice: 3200,
    category: "festive",
    color: "Blush Rose",
    colorHex: "#E2B4BD",
    fabric: "Hand-block printed chanderi silk with zari accents",
    badge: "New",
    rating: 4.9,
    reviews: 128,
    sizes: SIZES,
    description:
      "A heirloom short kurti sculpted for poised afternoons. The chanderi weave catches light softly, while subtle zari trims at the neckline trace a hand-drawn rose motif.",
    images: [
      "https://images.unsplash.com/photo-1763294631806-b414045e086c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/31808646/pexels-photo-31808646.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.pexels.com/photos/14045669/pexels-photo-14045669.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "mira-petal",
    name: "Mira Petal Kurti",
    price: 1890,
    originalPrice: 2400,
    category: "casual",
    color: "Peony Pink",
    colorHex: "#F4DCD6",
    fabric: "Breathable cotton voile with delicate thread work",
    badge: "Best Seller",
    rating: 4.8,
    reviews: 214,
    sizes: SIZES,
    description:
      "A soft-structured short kurti cut from airy cotton voile. Petal-like scallops at the hem lend movement, ideal for brunch dates and sunlit walks.",
    images: [
      "https://images.unsplash.com/photo-1768033976358-875c5dd27fc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/35445207/pexels-photo-35445207.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "noor-blossom",
    name: "Noor Blossom Anarkali",
    price: 3790,
    originalPrice: 4600,
    category: "festive",
    color: "Maroon Wine",
    colorHex: "#6D2C3B",
    fabric: "Dupion silk with hand embroidered florals",
    badge: "Limited",
    rating: 5.0,
    reviews: 74,
    sizes: SIZES,
    description:
      "An anarkali with tiered flow, hand-embroidered with tiny cherry blossoms in tonal threads. Finished with a soft maroon piping at the yoke.",
    images: [
      "https://images.pexels.com/photos/31808646/pexels-photo-31808646.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.pexels.com/photos/14045669/pexels-photo-14045669.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "sia-rosewater",
    name: "Sia Rosewater Tunic",
    price: 1590,
    category: "daily",
    color: "Rosewater",
    colorHex: "#FDF3F5",
    fabric: "Organic cotton mul with mother-of-pearl buttons",
    rating: 4.7,
    reviews: 96,
    sizes: SIZES,
    description:
      "A quiet every-morning tunic. Unbleached organic cotton mul shaped into a breezy silhouette, finished with small mother-of-pearl buttons.",
    images: [
      "https://images.unsplash.com/photo-1767687700430-d1b2997ae598?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1763294631806-b414045e086c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "amaya-bloom",
    name: "Amaya Bloom Co-ord",
    price: 3290,
    originalPrice: 3800,
    category: "festive",
    color: "Dusty Rose",
    colorHex: "#E2B4BD",
    fabric: "Tussar silk with thread-painted blooms",
    badge: "New",
    rating: 4.9,
    reviews: 52,
    sizes: SIZES,
    description:
      "A two-piece reverie. Relaxed kurti paired with softly pleated pants, both washed in dusty rose and hand-painted with clustered blooms.",
    images: [
      "https://images.pexels.com/photos/35445207/pexels-photo-35445207.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1768033976358-875c5dd27fc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "ishqa-ivory",
    name: "Ishqa Ivory Kurti",
    price: 2190,
    category: "casual",
    color: "Ivory Cream",
    colorHex: "#FCF8F8",
    fabric: "Soft linen with pastel thread stripes",
    rating: 4.6,
    reviews: 143,
    sizes: SIZES,
    description:
      "A transitional linen short kurti with slow, pastel pinstripes. Architectural cut at the sleeves, easy everywhere else.",
    images: [
      "https://images.unsplash.com/photo-1763294631806-b414045e086c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/31808646/pexels-photo-31808646.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "rani-velvet",
    name: "Rani Velvet Kurti",
    price: 4290,
    originalPrice: 5200,
    category: "festive",
    color: "Deep Maroon",
    colorHex: "#6D2C3B",
    fabric: "Silk velvet with zari gota patti",
    badge: "Best Seller",
    rating: 4.9,
    reviews: 187,
    sizes: SIZES,
    description:
      "A winter-evening showstopper. Silk velvet cut to skim the body, accented with softly glimmering gota patti trims at the cuffs.",
    images: [
      "https://images.pexels.com/photos/14045669/pexels-photo-14045669.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.pexels.com/photos/35445207/pexels-photo-35445207.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "suhana-pastel",
    name: "Suhana Pastel Kurti",
    price: 1690,
    category: "daily",
    color: "Pastel Pink",
    colorHex: "#F4DCD6",
    fabric: "Soft cotton with hand embroidered neckline",
    rating: 4.7,
    reviews: 108,
    sizes: SIZES,
    description:
      "A pastel companion for long workdays. Airy cotton, side slits for ease, and a tiny hand-embroidered floral trail at the neckline.",
    images: [
      "https://images.unsplash.com/photo-1767687700430-d1b2997ae598?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1763294631806-b414045e086c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "kaira-peach",
    name: "Kaira Peach Short Kurti",
    price: 1990,
    originalPrice: 2500,
    category: "casual",
    color: "Peach Sorbet",
    colorHex: "#F4DCD6",
    fabric: "Cotton slub with vintage buttons",
    badge: "New",
    rating: 4.8,
    reviews: 67,
    sizes: SIZES,
    description:
      "A cropped silhouette with lantern sleeves and weather-worn vintage buttons. Pairs beautifully with linen trousers or dhoti pants.",
    images: [
      "https://images.unsplash.com/photo-1768033976358-875c5dd27fc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.pexels.com/photos/31808646/pexels-photo-31808646.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "jaanvi-gulab",
    name: "Jaanvi Gulab Set",
    price: 3590,
    category: "festive",
    color: "Rose Gold",
    colorHex: "#E2B4BD",
    fabric: "Organza with rose-gold sequins",
    rating: 4.8,
    reviews: 91,
    sizes: SIZES,
    description:
      "Whispered organza layered over a blush slip, finished with clusters of rose-gold sequins. Weightless, romantic, unforgettable.",
    images: [
      "https://images.pexels.com/photos/31808646/pexels-photo-31808646.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.pexels.com/photos/35445207/pexels-photo-35445207.jpeg?auto=compress&cs=tinysrgb&w=1400",
    ],
  },
  {
    id: "zoya-meadow",
    name: "Zoya Meadow Kurti",
    price: 2090,
    category: "daily",
    color: "Soft Blush",
    colorHex: "#FDF3F5",
    fabric: "Rayon crepe with ditsy floral print",
    rating: 4.6,
    reviews: 132,
    sizes: SIZES,
    description:
      "A breezy rayon kurti printed with a ditsy meadow of roses. Relaxed at the torso, softly gathered at the hem.",
    images: [
      "https://images.unsplash.com/photo-1763294631806-b414045e086c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      "https://images.unsplash.com/photo-1767687700430-d1b2997ae598?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
  {
    id: "tara-twilight",
    name: "Tara Twilight Kurti",
    price: 2890,
    originalPrice: 3600,
    category: "festive",
    color: "Mauve Twilight",
    colorHex: "#C88C97",
    fabric: "Georgette with pearl hand beading",
    badge: "Limited",
    rating: 4.9,
    reviews: 58,
    sizes: SIZES,
    description:
      "Mauve georgette shaped into a fluid silhouette, hand-beaded at the yoke with freshwater pearls for soft evening shimmer.",
    images: [
      "https://images.pexels.com/photos/14045669/pexels-photo-14045669.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1768033976358-875c5dd27fc1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    ],
  },
];

export const COLORS = [
  { name: "Blush Rose", hex: "#E2B4BD" },
  { name: "Peony Pink", hex: "#F4DCD6" },
  { name: "Rosewater", hex: "#FDF3F5" },
  { name: "Deep Maroon", hex: "#6D2C3B" },
  { name: "Ivory Cream", hex: "#FCF8F8" },
  { name: "Mauve Twilight", hex: "#C88C97" },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Ananya R.",
    city: "Guwahati",
    quote:
      "The Rose Mirage kurti feels like it was stitched for me. Soft, light, and everyone keeps asking where it's from.",
    rating: 5,
    avatar: "https://images.pexels.com/photos/35445207/pexels-photo-35445207.jpeg?auto=compress&cs=tinysrgb&w=400",
  },
  {
    id: "t2",
    name: "Ishita S.",
    city: "Bengaluru",
    quote:
      "Every piece feels quietly luxurious. Flownté has become my go-to for festive gifting — my sisters and I practically live in them.",
    rating: 5,
    avatar: "https://images.pexels.com/photos/14045669/pexels-photo-14045669.jpeg?auto=compress&cs=tinysrgb&w=400",
  },
  {
    id: "t3",
    name: "Meher K.",
    city: "Delhi",
    quote:
      "The fabric, the finish, the fit — everything breathes grace. Wore the Rani Velvet to a cousin's sangeet and felt unreal.",
    rating: 5,
    avatar: "https://images.unsplash.com/photo-1767687700430-d1b2997ae598?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
];

export const GALLERY = [
  "https://flownte.com/uploads/7d30619386d741bfa1c8a5c1ca7c379b.jpg",
  "https://flownte.com/uploads/da0f63098d944c9a84fabd4ade81f730.png",
  "https://flownte.com/uploads/e736f431cf524f2abc211b1383bc70d0.png",
  "https://flownte.com/uploads/07be29e2ec7a42e09a7db4a04bbfd319.png",
  "https://flownte.com/uploads/dd2a854a3c24479a975f865690c30aa0.png",
  "https://flownte.com/uploads/19cb8e59d4ee48cfbfba37692362d866.png",
];

export const REVIEWS_BY_PRODUCT = {
  default: [
    {
      id: "r1",
      name: "Priya M.",
      rating: 5,
      date: "2 weeks ago",
      title: "Soft and so beautifully tailored",
      body:
        "The fabric feels truly premium and the fit is flattering without being tight. Received compliments all evening.",
    },
    {
      id: "r2",
      name: "Kavya T.",
      rating: 5,
      date: "1 month ago",
      title: "My third Flownté, never disappoints",
      body:
        "The craftsmanship is consistent, the colours are exactly as shown, and the packaging feels like a little gift.",
    },
    {
      id: "r3",
      name: "Riya D.",
      rating: 4,
      date: "2 months ago",
      title: "Worth every rupee",
      body:
        "Size M fit me perfectly. Would love a slightly longer length variant for taller silhouettes.",
    },
  ],
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_3836f01b-6ffc-40aa-bb61-1953ce280557/artifacts/dhzmpo1d_IMG_5947.jpeg";

export function getProductById(id) {
  return PRODUCTS.find((p) => p.id === id);
}

export function getRelatedProducts(productId, limit = 4) {
  const product = getProductById(productId);
  if (!product) return PRODUCTS.slice(0, limit);
  return PRODUCTS.filter(
    (p) => p.id !== productId && p.category === product.category
  ).slice(0, limit);
}
